<app-breadcrumb [title]="'Soporte Digitales'" [items]="['Vehículos']" [active_item]="'Digitales'"></app-breadcrumb>

<div class="container-fluid py-2 py-md-3">
  <div *ngIf="!soportesListos || cargandoSoportesExistentes" class="loading-banner d-flex align-items-center gap-3 py-3 px-4 mb-4 rounded-3 shadow-sm" role="status" aria-live="polite">
    <div class="spinner-border text-primary" aria-hidden="true"></div>
    <div>
      <div class="fw-semibold text-primary">Verificando soportes cargados</div>
      <small class="text-muted">Estamos consultando los archivos previamente cargados para este vehículo.</small>
    </div>
  </div>

 <div class="card border-0 shadow-lg mb-4" id="status-summary" style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);">
    <div class="card-body p-4 p-md-5">
      <div class="row align-items-center g-4">
        <div class="col-lg-8">
          <div class="d-flex align-items-center">
            <div class="bg-white bg-opacity-25 rounded-3 p-3 me-4 shadow" style="width: 65px; height: 65px; display: flex; align-items: center; justify-content: center;">
              <i class="icofont icofont-cloud-upload  text-white" style="font-size: 2.2rem;"></i>
            </div>
            <div class="text-white">
              <h5 class="mb-2 fw-bold">Documentos Cargados</h5>
              <p class="mb-0" style="font-size: 0.95rem;">
                <i class="icofont icofont-cloud-upload me-2"></i>
                <strong>{{ getQuantidadSoportesCargados() }}</strong>
                <span class="text-white-50 mx-2">de</span>
                <strong>{{ archivos.length }}</strong>
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-4 text-lg-end mt-3 mt-lg-0">
          <div class="bg-white bg-opacity-25 rounded-3 p-2 shadow">
            <h2 class="mb-0 text-white fw-bold" style="font-size: 1.7rem;">{{ getPorcentajeSoportes() }}<span class="percentage-symbol" style="font-size: 0.7rem;">%</span></h2>
            <p class="text-white mb-1" style="font-size: 0.80rem;">Completado</p>
            <div class="progress" style="height: 5px;" role="progressbar" [attr.aria-valuenow]="getPorcentajeSoportes()" aria-valuemin="0" aria-valuemax="100">
              <div class="progress-bar progress-bar-animated" [style.width.%]="getPorcentajeSoportes()" [class.bg-success]="getPorcentajeSoportes() === 100" [class.bg-warning]="getPorcentajeSoportes() > 0 && getPorcentajeSoportes() < 100"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="row gy-3 gy-md-4" id="documents-grid">
    <div *ngFor="let archivo of archivos" class="col-12 col-sm-6 col-lg-4 col-xl-3">
      <div class="card shadow-sm rounded h-100 d-flex flex-column document-card" [attr.data-document-id]="archivo.id">
        <div class="card-header bg-primary text-white text-center fw-bold">
          {{ archivo.nombre | uppercase }}
        </div>

        <div class="card-body d-flex flex-column align-items-center justify-content-center">
          <div class="w-100 d-flex justify-content-between align-items-center mb-2 soporte-status">
            <span *ngIf="archivo.soporteExistente" class="badge bg-success-subtle text-success border border-success-subtle">
              Soporte cargado
            </span>
             <span *ngIf="!archivo.soporteExistente" class="badge bg-warning-subtle text-dark border border-warning-subtle d-flex align-items-center gap-1">
              <i class="icofont icofont-warning-alt text-warning" style="font-size: 0.85rem;"></i>
              Sin soporte cargado
            </span>
            <span *ngIf="archivo.file" class="badge bg-primary-subtle text-primary border border-primary-subtle">
              Nuevo archivo seleccionado
            </span>
            <span *ngIf="archivo.verificandoSoporte" class="badge bg-info-subtle text-info border border-info-subtle d-flex align-items-center gap-1">
              <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
              Cargando
            </span>
          </div>

          <input 
            type="file" 
            class="d-none" 
            (change)="onFileChange($event, archivo.id)" 
            [id]="'fileInput' + archivo.id" 
            [accept]="archivo.acceptedFormats" 
            aria-label="Subir archivo {{ archivo.nombre }}">
            
          <label 
            [for]="'fileInput' + archivo.id" 
            class="dropzone-label w-100 d-flex flex-column align-items-center justify-content-center py-4 border border-primary rounded cursor-pointer"
            [class.has-file]="archivo.file"
            tabindex="0"
            (keydown.enter)="document.getElementById('fileInput' + archivo.id)?.click()"
            (keydown.space)="document.getElementById('fileInput' + archivo.id)?.click()"
             (dragover)="onDragOver($event)"
             (dragleave)="onDragLeave($event)"  (drop)="onDrop($event, archivo.id)"
             
            >
            
            <ng-container *ngIf="archivo.file; else soporteExistenteONada">
              <img 
                *ngIf="isImage(archivo.file.file)" 
                [src]="archivo.file.preview" 
                class="preview-img mb-2 rounded shadow-sm" 
                (click)="verImagenCompleta(archivo.file.preview)"
                
                alt="Preview de {{ archivo.nombre }}"
                role="button"
                title="Click para ampliar">
              
              <div 
                *ngIf="!isImage(archivo.file.file)" 
                class="pdf-preview-icon d-flex flex-column align-items-center text-danger mb-2"
                role="img"
                aria-label="Archivo PDF">
                <i class="fa fa-pdf"></i>
                <small>Archivo PDF</small>
              </div>

              <small class="text-muted text-truncate" [title]="archivo.file.file.name">{{ archivo.file.file.name }}</small>
            </ng-container>

            <ng-template #soporteExistenteONada>
              <ng-container *ngIf="archivo.soporteExistente; else noFile">
                <img
                  *ngIf="archivo.soporteExistente.isImage"
                  [src]="archivo.soporteExistente.url"
                  class="preview-img mb-2 rounded shadow-sm"
                  (click)="verSoporteExistente(archivo)"
                  alt="Soporte existente de {{ archivo.nombre }}"
                  role="button"
                  title="Click para ampliar">

                <div
                  *ngIf="!archivo.soporteExistente.isImage"
                  class="pdf-preview-icon d-flex flex-column align-items-center text-danger mb-2"
                  role="button"
                  title="Click para ver"
                  (click)="verSoporteExistente(archivo)">
                  <i class="icofont icofont-file-pdf fs-1"></i>
                  <small>PDF cargado</small>
                </div>

                <small class="text-muted text-truncate" [title]="archivo.soporteExistente.name">
                  {{ archivo.soporteExistente.name }}
                </small>
              </ng-container>
            </ng-template>

            <ng-template #noFile>
              <i class="icofont icofont-upload fs-1 text-primary mb-2"></i>
              <p class="mb-2 fw-semibold text-primary text-center">Haz click o arrastra para cargar</p>
              <span class="btn btn-primary btn-sm rounded-pill px-3">Cargar soporte</span>
            </ng-template>
          </label>
        </div>

        <div *ngIf="archivo.estado === 'subiendo'" class="progress my-2 mx-3" role="progressbar" aria-valuemin="0" aria-valuemax="100" [attr.aria-valuenow]="archivo.progreso">
          <div class="progress-bar progress-bar-striped progress-bar-animated" [style.width.%]="archivo.progreso">
            {{ archivo.progreso }}%
          </div>
        </div>

        <div *ngIf="archivo.estado === 'exito'" class="alert alert-success mx-3 my-2 text-center py-1" role="alert">
          {{ archivo.mensaje }}
        </div>

        <div *ngIf="archivo.estado === 'error'" class="alert alert-danger mx-3 my-2 text-center py-1" role="alert">
          {{ archivo.mensaje }}
        </div>

        <div class="card-footer d-flex flex-column flex-sm-row justify-content-center gap-2">
          <button
            *ngIf="!archivo.file && archivo.soporteExistente"
            class="btn btn-outline-primary btn-sm"
            (click)="verSoporteExistente(archivo)">
            <i class="icofont icofont-eye me-1"></i> Ver
          </button>
          <button
            *ngIf="!archivo.file && archivo.soporteExistente"
            class="btn btn-secondary text-white btn-sm"
            (click)="reemplazarSoporte(archivo.id)">
            <i class="icofont icofont-refresh me-1"></i> Reemplazar
          </button>
            
          <button 
            *ngIf="archivo.file" 
            class="btn btn-success btn-sm" 
            (click)="subirArchivo(archivo.id,'vehiculos', archivo.prefijo)">
            <i class="bi bi-cloud-check me-1"></i> Enviar
          </button>
          <button 
            *ngIf="archivo.file" 
            class="btn btn-danger btn-sm" 
            (click)="removeFile(archivo.id)">
            <i class="bi bi-trash me-1"></i> Eliminar
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="imagenGrande" class="modal-backdrop d-flex align-items-center justify-content-center" (click)="cerrarImagenCompleta()">
  <div class="modal-content p-3 bg-white shadow-lg" style="max-width: 90vw; max-height: 90vh;" (click)="$event.stopPropagation()">
    <div class="d-flex justify-content-end mb-2">
      <button class="btn btn-sm btn-outline-secondary" (click)="cerrarImagenCompleta()">Cerrar</button>
    </div>
    <img [src]="imagenGrande" class="zoomable" alt="Vista previa ampliada" (wheel)="hacerZoom($event)">
  </div>
</div>
